// src/pages/ExamSystemPage.jsx
import React from "react";
import ExaminationHistory from "../../Components/ExaminationHistory/ExaminationHistory";
import "./ExamsQuizzes.css";
import { useNavigate } from "react-router-dom";

// Import Ant Design icons
import {
  FileTextOutlined,    // For Exams
  EditOutlined,        // For Quizzes
  ClockCircleOutlined, // For Tests
  BookOutlined,
  CalculatorOutlined,
  ExperimentOutlined,
  GlobalOutlined,
  HistoryOutlined
} from "@ant-design/icons";

const ExamsQuizzes = () => {
  const navigate = useNavigate('');

  const handleNavigationToExam = async () => {
    navigate('/exam-system-start')
  }

  return (
    <div className="exam-system-page">
      {/* Main content container */}
      <div className="exam-system-container">
        {/* Header section matching RN structure */}
        <div className="exam-system-header-section">
          <h1 className="exam-system-heading">Prepare Yourself Today</h1>
          <p className="exam-system-subheading">
            Select Education level, class & subject to start your generated exam
          </p>
          
          <h2 className="exam-system-title">Select Examination Plan</h2>
          
          {/* Cards grid */}
          <div className="exam-system-card-grid">
            {/* Exams Card */}
            <div 
              className="exam-system-card"
              onClick={handleNavigationToExam}
            >
              <div className="exam-system-card-icon" style={{ color: "#29d159ff" }}>
                <FileTextOutlined style={{ fontSize: '40px' }} />
              </div>
              <h3 className="exam-system-card-title">Exams</h3>
              <p className="exam-system-card-description">Complete exams with time limit</p>
            </div>
            
            {/* Quizzes Card */}
            <div 
              className="exam-system-card"
              onClick={handleNavigationToExam}
            >
              <div className="exam-system-card-icon" style={{ color: "#4a90e2" }}>
                <EditOutlined style={{ fontSize: '40px' }} />
              </div>
              <h3 className="exam-system-card-title">Quizzes</h3>
              <p className="exam-system-card-description">Quick quizzes for practice</p>
            </div>
            
            {/* Tests Card */}
            <div 
              className="exam-system-card"
              onClick={handleNavigationToExam}
            >
              <div className="exam-system-card-icon" style={{ color: "#ff6b6b" }}>
                <ClockCircleOutlined style={{ fontSize: '40px' }} />
              </div>
              <h3 className="exam-system-card-title">Test</h3>
              <p className="exam-system-card-description">Timed tests for assessment</p>
            </div>
          </div>
          
          {/* History Component */}
          <ExaminationHistory />
        </div>
      </div>
    </div>
  );
};

export default ExamsQuizzes;